import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Sidebar } from '../../components/shared/Sidebar';
import { DashboardHeader } from '../../components/shared/DashboardHeader';
import { PropertyCard } from '../../components/landlord/PropertyCard';
import { MOCK_PROPERTIES } from '../../utils/mockData';
import { motion } from 'framer-motion';
import { Plus, Search, Filter } from 'lucide-react';
export function PropertyManagement() {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const filteredProperties = MOCK_PROPERTIES.filter(property => property.name.toLowerCase().includes(searchQuery.toLowerCase()) || property.address.toLowerCase().includes(searchQuery.toLowerCase()));
  return <div className="flex min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors pb-16 lg:pb-0" data-id="element-4074">
      <Sidebar data-id="element-4075" />

      <main className="flex-1 lg:ml-[240px] transition-all duration-300" data-id="element-4076">
        <DashboardHeader data-id="element-4077" />

        <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8 py-6 lg:py-8" data-id="element-4078">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-4079">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 lg:mb-8 gap-4" data-id="element-4080">
              <div className="min-w-0" data-id="element-4081">
                <h1 className="text-2xl font-bold text-gray-900 dark:text-white truncate" data-id="element-4082">
                  Properties
                </h1>
                <p className="mt-1 text-sm text-gray-500 dark:text-gray-400 line-clamp-2" data-id="element-4083">
                  Manage your rental portfolio and units.
                </p>
              </div>
              <button onClick={() => navigate('/landlord/property/new')} className="inline-flex items-center px-4 py-2 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 dark:bg-blue-700 dark:hover:bg-blue-800 transition-colors whitespace-nowrap flex-shrink-0" data-id="element-4084">
                <Plus className="h-4 w-4 mr-2 flex-shrink-0" data-id="element-4085" />
                Add Property
              </button>
            </div>

            {/* Search and Filter */}
            <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 p-4 mb-6 lg:mb-8 flex flex-col sm:flex-row gap-4 transition-colors" data-id="element-4086">
              <div className="relative flex-1" data-id="element-4087">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-4088">
                  <Search className="h-5 w-5 text-gray-400 dark:text-gray-500 flex-shrink-0" data-id="element-4089" />
                </div>
                <input type="text" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="block w-full pl-10 pr-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg leading-5 bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent sm:text-sm transition-colors" placeholder="Search properties by name, address, or tenant..." data-id="element-4090" />
              </div>
              <button className="inline-flex items-center px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg text-sm font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors whitespace-nowrap flex-shrink-0" data-id="element-4091">
                <Filter className="h-4 w-4 mr-2 flex-shrink-0" data-id="element-4092" />
                Filters
              </button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6" data-id="element-4093">
              {filteredProperties.map((property, idx) => <motion.div key={property.id} initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: idx * 0.05
            }} data-id="element-4094">
                  <PropertyCard property={property} data-id="element-4095" />
                </motion.div>)}

              {/* Add New Card */}
              <motion.button onClick={() => navigate('/landlord/property/new')} whileHover={{
              y: -4
            }} className="border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-xl p-6 flex flex-col items-center justify-center text-gray-400 dark:text-gray-500 hover:border-blue-500 dark:hover:border-blue-400 hover:text-blue-500 dark:hover:text-blue-400 hover:bg-blue-50 dark:hover:bg-blue-900/20 transition-all cursor-pointer h-full min-h-[300px]" data-id="element-4096">
                <div className="h-12 w-12 rounded-full bg-gray-100 dark:bg-gray-700 flex items-center justify-center mb-4" data-id="element-4097">
                  <Plus className="h-6 w-6 flex-shrink-0" data-id="element-4098" />
                </div>
                <span className="text-sm font-medium" data-id="element-4099">Add New Property</span>
              </motion.button>
            </div>

            {filteredProperties.length === 0 && searchQuery && <div className="text-center py-12" data-id="element-4100">
                <Search className="h-12 w-12 mx-auto text-gray-300 dark:text-gray-600 mb-4" data-id="element-4101" />
                <p className="text-gray-500 dark:text-gray-400" data-id="element-4102">
                  No properties found matching "{searchQuery}"
                </p>
              </div>}
          </motion.div>
        </div>
      </main>
    </div>;
}